import React, { Component } from "react";
import { Switch, Link, Route } from "react-router-dom";
import withAuth from "./../auth_components/js/withAuth";
import Navbar from "../Components/Navbar";
import AddNewContainer from "../Components/AddNew/AddNewContainer";
import EditNewContainer from "../Components/AddNew/EditNewContainer";
import AddNewCo from "../Components/Department/CO/AddNewCo";
import EditNewCo from "../Components/Department/CO/EditNewCo";
import CoLanding from "../Components/Department/CO/CoLanding";
import AddNewActivity from "../Components/Department/Activity/AddNewActivity";
import ActivityLanding from "../Components/Department/Activity/ActivityLanding";
import EditNewActivity from "../Components/Department/Activity/EditNewActivity";
import AddFacilityActivity from "../Components/Department/Facility/AddFacilityActivity";
import EditNewFacility from "../Components/Department/Facility/EditNewFacility";
import FacilityLanding from "../Components/Department/Facility/FacilityLanding";
import AddGalleryActivity from "../Components/Department/Gallery/AddGalleryActivity";
import EditNewGallery from "../Components/Department/Gallery/EditNewGallery";
import GalleryLanding from "../Components/Department/Gallery/GalleryLanding";

class AddNewContainerMain extends Component {
  constructor(props) {
    super(props);

    let user = JSON.parse(localStorage.getItem("user"));

    this.state = {
      apikey: user.user.apikey,
      username: user.user.email,
      name: user.user.name,
      role: user.user.name,
    };
  }

  render() {
    return (
      <div>
        <Navbar history={this.props.history} />
        <div className="main-body">
          <Switch>
            <Route
              exact
              path="/notices"
              render={(props) => (
                <AddNewContainer
                  {...props}
                  history={this.props.history}
                  title="Notification"
                  code="notice"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/tender"
              render={(props) => (
                <AddNewContainer
                  {...props}
                  history={this.props.history}
                  title="Tender"
                  code="tender"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/news"
              render={(props) => (
                <AddNewContainer
                  {...props}
                  history={this.props.history}
                  title="News"
                  code="news"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/events"
              render={(props) => (
                <AddNewContainer
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/edit"
              render={(props) => (
                <EditNewContainer
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/courseoutcome/add"
              render={(props) => (
                <AddNewCo
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/courseoutcome/edit"
              render={(props) => (
                <EditNewCo
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/courseoutcome/view"
              render={(props) => (
                <CoLanding
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/activity/add"
              render={(props) => (
                <AddNewActivity
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/activity/edit"
              render={(props) => (
                <EditNewActivity
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/activity/view"
              render={(props) => (
                <ActivityLanding
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/facility/add"
              render={(props) => (
                <AddFacilityActivity
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/facility/edit"
              render={(props) => (
                <EditNewFacility
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/facility/view"
              render={(props) => (
                <FacilityLanding
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/gallery/add"
              render={(props) => (
                <AddGalleryActivity
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/gallery/edit"
              render={(props) => (
                <EditNewGallery
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />

            <Route
              exact
              path="/gallery/view"
              render={(props) => (
                <GalleryLanding
                  {...props}
                  history={this.props.history}
                  title="Events"
                  code="events"
                  apikey={this.state.apikey}
                  username={this.state.username}
                />
              )}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withAuth(AddNewContainerMain);



// WEBPACK FOOTER //
// ./src/Containers/AddNewContainerMain.js